import { Badge, PulseDot } from '../ui';
import type { Prospect } from './DealCard';
import { adsClickKind, adsUploadState } from './meta';

interface AdsBadgeProps {
  prospect: Prospect;
}

/**
 * Two independent signals next to the deal amount:
 *  - "Ads" pill: the lead arrived through a Google click (gclid/gbraid/wbraid).
 *  - status dot: Project Signal upload state — green sent, amber waiting for the
 *    next upload, red failed. Shown for any card the uploader handles, including
 *    email-matched leads with no click id. Hover for the detail.
 * Renders nothing when neither applies.
 */
export default function AdsBadge({ prospect }: AdsBadgeProps) {
  const kind = adsClickKind(prospect);
  const upload = adsUploadState(prospect);
  if (!kind && !upload) return null;

  const match = kind ? `matched by ${kind}` : 'matched by email, no click id';
  const title = upload ? `${upload.title} (${match})` : `From Google Ads (${kind} captured)`;

  return (
    <span title={title} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', flexShrink: 0 }}>
      {kind ? <Badge tone="accent">Ads</Badge> : null}
      {upload ? <PulseDot tone={upload.tone} pulse={upload.tone !== 'up'} /> : null}
    </span>
  );
}
